export const CART_ADD_ITEM = 'CART_ADD_ITEM'
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM'
export const CART_ADD_ITEM_TO_STORAGE = 'CART_ADD_ITEM_TO_STORAGE'
export const CART_RESET_ITEM = 'CART_RESET_ITEM'

export const CART_GET_DATA_FROM_SERVER = 'CART_GET_DATA_FROM_SERVER'
